// 1. The TrustPilotReview component is a straightforward Next.js client-side component that integrates a TrustBox from the commercetools-ui library.
// 2. It uses the 'use client' directive, indicating it’s designed for client-side rendering in a Next.js app.
// 3. It uses the usePathname hook from Next.js’s next/navigation to get the current pathname. This allows it to conditionally render content based on the current route.
// 4. The component sets isHome to true if the pathname matches the root path (assumed to be '/en/'), which can be useful for tailoring the review component’s behavior for the homepage.
// 5. The TrustBox component, imported from commercetools-ui, receives isHome as a prop. This allows TrustBox to potentially render differently or include different settings when on the homepage.
// 6. TrustPilotReview is essentially a wrapper around TrustBox, handling logic to determine if the page is the homepage, and then passing the result to TrustBox.
'use client';
import TrustBox from 'components/commercetools-ui/organisms/trustpilot';
import React from 'react';
import { TasticProps } from '../types';
import { usePathname } from 'next/navigation';
import { TrustPilotData } from 'types/next';

const TrustPilotReviewTastic = ({ data }: TasticProps<TrustPilotData>) => {
  const pathname = usePathname();
  let isHome;
  if (pathname === '/en/') {
    isHome = true;
  }

  return (
    <div>
      <TrustBox home={isHome} trustPilotdata={data} />
    </div>
  );
};

export default TrustPilotReviewTastic;
